/*
Instant-access customizer unlock.

Anonymous visitors who submit an "instant access" form (exterior visualizer or
interactive floorplan) get an `ifp_signup` cookie that reveals the customizer
"you now have access" state on masterplan, plan, and spec detail pages — no
login required. Either form unlocks every [data-instant-access] section on the
page, matching legacy keystone's "hide all overlays" behavior.
*/

const INSTANT_ACCESS_COOKIE = "ifp_signup";

const revealInstantAccess = () => {
    document.querySelectorAll("[data-instant-access]").forEach((section) => {
        section.querySelector(".instant-access-form")?.classList.add("d-none");
        section.querySelector(".instant-access-granted")?.classList.remove("d-none");
    });
};

document.addEventListener("DOMContentLoaded", () => {
    if (oi.utils.cookie.get(INSTANT_ACCESS_COOKIE)) {
        revealInstantAccess();
    }
});

["elevationsinstantaccessform", "floorplansinstantaccessform"].forEach((form_name) => {
    window.addEventListener(`oi.loaded.form.${form_name}`, () => {
        oi.loaded.form[form_name].addSuccessAction = () => {
            oi.utils.cookie.set(INSTANT_ACCESS_COOKIE, "true");
            revealInstantAccess();
        };
    });
});
